
export const MailchimpForm = () => {
  
  return (
    <>
    <p><h1>Also contact on:</h1> <a href="sonurav@hotmail.com">@darkside96000</a></p>
    </>
  )
}
